<emperor-card-header class="emperor-dialog-header-container" [color]="color">
    <div class="emperor-dialog-title" *ngIf="title">{{ title }}</div>
    <div *ngIf="shouldShowClose" emperorDialogClose role="button" tabindex="0" aria-label="Close dialog" class="emperor-dialog-close">
      <emperor-icon name="close_1"></emperor-icon>
    </div>
</emperor-card-header>
